import { assertUnreachable } from '../guards/assertUnreachable';

import {
   createDocumentBlob,
   DocumentAsBase64,
   DocumentAsUrl,
   fetchDocumentBlob,
   HtmlDocumentAsBase64,
   MimeType,
} from './getDocumentAsBlob.utils';

export type Document = DocumentAsBase64 | DocumentAsUrl | HtmlDocumentAsBase64;
export type DocumentBlob = Blob;
export type DocumentStrategy = {
   loadPrintFrame: (printFrame: HTMLIFrameElement) => Promise<void> | void;
   onPrintFrameLoad: VoidFunction;
};

export const getDocumentBlob = (document: Document): DocumentBlob | Promise<DocumentBlob> => {
   if ('base64' in document) {
      return createDocumentBlob(document.base64, MimeType.APPLICATION_PDF);
   }

   if ('url' in document) {
      return fetchDocumentBlob(document.url);
   }

   if ('htmlBase64' in document) {
      return createDocumentBlob(document.htmlBase64, MimeType.TEXT_HTML);
   }

   return assertUnreachable(document);
};
